import SchemaMarkup from "../Components/SchemaMarkup";

const ReviewSchema = ({ testimonials }) => {
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",

    "@id": "https://msayurved.com/testimonials/#reviews",

    "itemListElement": testimonials.map((item, index) => ({
      "@type": "ListItem",

      "position": index + 1,

      "item": {
        "@type": "Review",

        "author": {
          "@type": "Person",
          "name": item.title
        },

        "reviewBody": item.desc,

        "reviewRating": {
          "@type": "Rating",
          "ratingValue": 5,
          "bestRating": 5,
          "worstRating": 1
        },

      "itemReviewed": {
  "@type": "MedicalClinic",
  "@id": "https://msayurved.com/#medicalclinic",
  "name": "Dr. Jigar Gor's Ayurveda Center"
}
      }
    }))
  };

  return <SchemaMarkup data={schema} />;
};

export default ReviewSchema;